import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency, { isCurrency } from 'modules/core/lib/money'

export const getProjectSubprojectName = (
  projectName: string,
  subprojectName: string | undefined,
  hasFeature = true
) => {
  let name = ''

  if (projectName) {
    name = projectName
  }
  if (hasFeature && subprojectName) {
    name += ' · ' + subprojectName
  }

  return name
}

export const getFixedTimeBudgetProgressBarLabel = (
  imputedMinutes: string,
  budgetAllocation: string
) => {
  return imputedMinutes + ' / ' + budgetAllocation
}

export const MoneyWithStringCurrency = (amount: number, currency: string, locale: string) => {
  if (isCurrency(currency)) {
    return MoneyWithCurrency({
      amount,
      currency,
      locale,
      optionalDecimals: true,
    })
  } else {
    return '-'
  }
}

export const getFixedCostPlanningProgressBarLabel = (
  cost: number,
  budgetAllocationCents: number,
  currency: string,
  locale: string
) => {
  return `${MoneyWithStringCurrency(cost, currency, locale)} / ${MoneyWithStringCurrency(
    budgetAllocationCents,
    currency,
    locale
  )}`
}

export const getLevelsDisplayText = (levelsCount: number): string => {
  if (!levelsCount)
    return i18n.t('project_management.jobs_and_rates.sidepanels.form.select_jobs.label')

  return i18n.tp('project_management.jobs_and_rates.sidepanels.form.select_jobs.message', {
    count: levelsCount,
  })
}
